import script from "./SearchRPTaxAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchRPTaxAccount.vue?vue&type=script&setup=true&lang=js"

import "./SearchRPTaxAccount.vue?vue&type=style&index=0&id=0079cd01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0079cd01"]])

export default __exports__